<template>
  <div class="grid-view">
    <div class="main-content" style="margin-left: 10px;">
      <search-item
        ref="searchItem"
        config-module="210101"
        :show-more-scheme="true"
        :show-simple="false"
        :expand-adv="true"
        :custom-sim-query-placeholder="$t('CargoMsg.Cargo_PlsInput')+$t('Pricing.FileName')"
        sim-url=""
        adv-url=""
        :custom-search-items="customSearchItems"
        @query="toQuery"
      />
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="151115"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="151114"
          :total="pageConditions.total"
          :page.sync="pageConditions.pageNum"
          :limit.sync="pageConditions.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as businessDocumentApi from '@/api/businessDocument'
import { cache } from '@/utils/cacheManager'
import { getToken } from '@/utils/auth'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import URL from '@/api/urlTranslator'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'PriceFileManager',
  components: { searchItem },
  data() {
    return {
      showSimple: true,
      TYPE_NAMES: TYPE_NAMES,
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Pricing.FileName'),
          field: 'fileName',
          width: 150
        }, {
          headerName: this.$t('Pricing.DocumentId'),
          field: 'documentId',
          width: 300
        }, {
          headerName: this.$t('Pricing.CreatedBy'),
          field: 'createdBy',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('Pricing.DocumentCategory'),
          field: 'documentCategory',
          width: 150,
          cellRenderer: (params) => {
            return this.documentCategoryColumnLabel(params.value)
          }
        }, {
          headerName: this.$t('Pricing.CreatedDate'),
          field: 'dateCreated',
          width: 150
        }, {
          headerName: this.$t('Pricing.FileSize'),
          field: 'fileSize',
          width: 150,
          cellRenderer: params => {
            return this.fileSizeColumnLabel(params.value)
          }
        }, {
          headerName: this.$t('Pricing.Remarks'),
          field: 'remarks',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ViewFile'),
          field: '',
          width: 150,
          cellRenderer: params => {
            // const storageURL = cache.config.get('StorageURL')
            const sessionId = getToken()
            return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${sessionId}" target="_blank" style="color:#032bc6">${this.$t('SeaExport.ViewFile')}</a>`
          }
        }, {
          headerName: this.$t('FileHistory.HasDeleted'),
          field: 'fileDeleted',
          width: 100,
          cellRenderer: (params) => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }
      ],
      pageConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      lastConditions: [],
      customSearchItems: []
    }
  },
  async created() {
    const searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'advanceSelect'
    searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
    searchField.itemName = 'business_document.DOCUMENT_CATEGORY'
    searchField.itemLabel = 'Pricing.DocumentCategory'
    searchField.tagValue = 'code'
    searchField.defaultSelected = 1
    searchField.dataProvider = [...DocumentConstants.DOCUMENT_CATEGORY_PRICE]
    // 分页
    searchField.subType = {
      'page': true,
      'pageSize': 50
    }
    searchField.filterType = 'global'
    this.customSearchItems.push(searchField.formatObj2Json())
  },
  activated() {
    const params = this.$route.params
    if (params.code) {
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'business_document.DOCUMENT_CATEGORY'
      searchField.itemLabel = this.$t('Pricing.DocumentCategory')
      searchField.tagName = 'chineseName'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.defaultValue = params.code
      searchField.dataProvider = [...DocumentConstants.DOCUMENT_CATEGORY_PRICE]
      // 分页
      searchField.subType = {
        'page': true,
        'pageSize': 50
      }
      searchField.filterType = 'global'
      this.customSearchItems.push(searchField.formatObj2Json())
      setTimeout(() => {
        this.$refs.searchItem.advSearch()
      }, 500)
    }
  },
  methods: {
    toQuery(param) {
      const params = {}
      if (param && 'conditions' in param) {
        if (param.simpleTriggerMode) {
          params.conditions = [new AdvancedSearchOption('FIELD_TEXT', 'business_document.FILE_NAME', '%' + param.conditions + '%', AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json()]
        } else {
          params.conditions = param.conditions
        }
        this.lastConditions = params.conditions
      } else {
        params.conditions = this.lastConditions
      }
      const DOCUMENT_CATEGORY = params.conditions.find(obj => obj.fieldName === 'business_document.DOCUMENT_CATEGORY')
      if (!DOCUMENT_CATEGORY) {
        params.conditions.push(new AdvancedSearchOption(null, 'business_document.DOCUMENT_CATEGORY', DocumentConstants.DOCUMENT_CATEGORY_PRICE_CODE, AdvancedSearchConsts.OPERATOR_IN.code))
      }
      params.pageNum = this.pageConditions.pageNum
      params.pageSize = this.pageConditions.pageSize
      // CARGO-44589 “上传日志”功能新增数据权限
      params.officeId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      businessDocumentApi.queryPage(params).then(resp => {
        const data = resp.data
        this.pageConditions.pageSize = data.pageSize
        this.pageConditions.pageNum = data.pageNum
        this.pageConditions.total = Number(data.total)
        this.rowData = data.list
      }).finally(() => loading.close())
    },
    fileSizeColumnLabel(value) {
      if (value) {
        return (value / 1024).toFixed(2).toString() + ' KB'
      }
      return ''
    },
    documentCategoryColumnLabel(category) {
      if (category > 0) {
        const el = DocumentConstants.DOCUMENT_CATEGORY_PRICE.find(el => el.code === category)
        return el ? this.$store.getters.language === 'zh' ? el.chineseName : el.englishName : ''
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>
